import React from "react";
import { makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  container: {
    padding: "20px",
    height: "calc(100vh - 40px)",
  },
});

const Container = ({ children }) => {
  const styles = useStyles();

  return <div className={styles.container}>{children}</div>;
};

export default Container;